import { configure } from 'safe-stable-stringify';
const stringify = configure({
    deterministic: true,
    strict: true,
});
export const safeStringify = (subject, replacer, space) => {
    const result = stringify(subject, replacer, space);
    if (result === undefined) {
        throw new Error('Expected result to be string');
    }
    return result;
};
//# sourceMappingURL=safeStringify.js.map